import React, {useMemo} from "react";
import {i18nFormat} from "../../lib/i18nFormat";
import {urlToPage} from "@shared/lib/urlToPage";
import {userManager} from "../../managers/UserManager";
import {subscriptionTypes} from "../../enums/subscriptionType";
import {useBackups} from "../../hooks/useBackups";
import {EmptyPageContent} from "../../components/EmptyPageContent";
import {BackupsSection} from "./BackupsSection";

export function BackupsPage() {
  const user = userManager.store(state => state.user); // User is updated on state change.
  const [homeysWithBackups, isLoading, removeBackup] = useBackups();

  const hasHomeyProBackupsSubscription = useMemo(() => {
    if (!user || !user.subscriptions) return false;
    return Object.keys(user.subscriptions).some(subscriptionId => {
      return subscriptionId === subscriptionTypes.HomeyPlusAthom ||
        subscriptionId === subscriptionTypes.HomeyPlusMonthlyApple ||
        subscriptionId === subscriptionTypes.HomeyPlusMonthlyGoogle;
    });
  }, [user]);

  if (isLoading) {
    return null;
  }
  if (!hasHomeyProBackupsSubscription) {
    return (
      <EmptyPageContent
        glyph={"glyph-system-backups"}
        title={i18nFormat("backups.no-backups-subscription.title")}
        text={i18nFormat("backups.no-backups-subscription.description")}
        link={{
          url: urlToPage("homey-pro-backups"),
          text: i18nFormat("backups.no-backups-subscription.learn-more"),
        }}
      />
    )
  }
  if (Object.keys(homeysWithBackups).length === 0) {
    return (
      <EmptyPageContent
        glyph={"glyph-system-backups"}
        title={i18nFormat("backups.no-backups.title")}
        text={i18nFormat("backups.no-backups.description")}
      />
    )
  }

  return (
    <section className="account-page account-backups">
      <header className="account-page__header">
        <h1 className="account-page__title">{i18nFormat("backups.title")}</h1>
        <p className="account-page__text">{i18nFormat("backups.subtitle")}</p>
      </header>
      {Object.entries(homeysWithBackups).map(([homeyId, homey]) => (
        <BackupsSection key={homeyId} homey={homey} onDelete={removeBackup}/>
      ))}
    </section>
  );
}